import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import { Text } from 'recharts';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ReactSelectMaterialUi from 'react-select-material-ui';
import classNames from 'classnames';
import { Link } from '@material-ui/core';
import TabPanelDetail from '../../components/atoms/TabPanelDetail';
import CancelButtonShop from '../../components/atoms/CancelButtonShop';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import ValidationText from '../../components/atoms/ValidationText';
import ShopEditConfirmShop from './ShopEditConfirmShop';
import FileUpload from '../../components/molecules/FileUpload';
import {
  getShops,
  editShop,
  addShopImage,
  countShopEmail,
  getZipCode
} from '../../actions/Shop';
import { sendLogin, resizeImage, uploadFile } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { getOptionCities } from '../../actions/Cities';
import { languages, languageType } from '../../constants/Language';
import { nameSystem } from '../../constants/TextSystem';
import { getTextBySystem } from '../../utils';

const styles = theme => ({
  root: {
    boxShadow: 'none'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  descriptionSmall: {
    fontSize: '0.875rem',
    color: '#707070',
    margin: '10px 0px 0px'
  },
  subDescription: {
    fontSize: '0.875rem'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    }
  },
  editTable: {
    width: 'auto',
    display: 'block',
    marginLeft: '-10px',
    marginRight: '-10px',
    '& tr': {
      display: 'block'
    }
  },
  tableCell90: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: 0,
    width: '100px'
  },
  textField: {
    padding: 0,
    width: '100%'
  },
  divider: {
    margin: '0px 0px 20px'
  },
  note: {
    padding: '10px'
  },
  tagCaution: {
    color: 'red',
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  textRed: {
    color: '#f00'
  },
  marginBottom10: {
    marginBottom: '10px'
  },
  marginBottom20: {
    marginBottom: '20px'
  },
  colLeft: {
    paddingLeft: 20,
    paddingRight: 20,
    display: 'block',
    border: 0,
    paddingBottom: 5
  },
  colRight: {
    paddingLeft: 20,
    paddingRight: 20,
    display: 'block',
    border: 0,
    paddingTop: 0
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  tabpanelHeader: {
    padding: '0 2px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 2px',
    backgroundColor: '#F7F7F7',
    borderRadius: '3px 3px 0 0',
    fontSize: 12,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #ffffff',
    width: '33%',
    minWidth: '100px',

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  borderBottom: {
    borderBottom: '1px solid #DDDDDD !important'
  },
  fs12: {
    fontSize: '12px !important'
  },
  boxButtonAction: {
    padding: '25px 20px 5px 20px',
    borderTop: '1px solid #DDDDDD'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  langDiv: {
    margin: '0 10px'
  },
  width320: {
    width: '320px'
  },
  disableInput: {
    backgroundColor: '#d9d9d9'
  },
  link: {
    textDecoration: 'underline'
  },
  textBlack: {
    color: 'black'
  },
  fw700: {
    fontWeight: 700
  },
  pb0: {
    paddingBottom: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      prefectures: state.commons.prefectures,
      cities: state.cities.listCities,
      statuses: state.shops.statuses,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getShops,
          editShop,
          addShopImage,
          countShopEmail,
          getAccounts,
          getOptionCities,
          getZipCode
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopId', 'setShopId', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', ''),
  withState('cityIdError', 'setCityIdError', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', 0),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('phone', 'setPhone', ''),
  withState('email', 'setEmail', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('image2', 'setImage2', null),
  withState('previewImage2', 'setPreviewImage2', null),
  withState('image3', 'setImage3', null),
  withState('previewImage3', 'setPreviewImage3', null),
  withState('image4', 'setImage4', null),
  withState('previewImage4', 'setPreviewImage4', null),
  withState('image5', 'setImage5', null),
  withState('previewImage5', 'setPreviewImage5', null),
  withState('stealthMode', 'setStealthMode', 'UNSTEALTH'),
  withState('stealthModeStr', 'setStealthModeStr', '表示'),
  withState('gochiRestriction', 'setGochiRestriction', 'ANY'),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', '制限なし'),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankName', 'setBankName', ''),
  withState('bankNameError', 'setBankNameError', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankBranchNameError', 'setBankBranchNameError', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('status', 'setStatus', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('shopNameKanaError', 'setShopNameKanaError', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('cityError', 'setCityError', ''),
  withState('addressError', 'setAddressError', ''),
  withState('contactPhoneError', 'setContactPhoneError', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('emailError', 'setEmailError', ''),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('shopCategoriesError', 'setShopCategoriesError', ''),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('snsFacebookError', 'setSnsFacebookError', ''),
  withState('snsTwitterError', 'setSnsTwitterError', ''),
  withState('snsInstagramError', 'setSnsInstagramError', ''),
  withState('shopContactNameError', 'setShopContactNameError', ''),
  withState('shopGroupNameError', 'setShopGroupNameError', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('address1Error', 'setAddress1Error', ''),
  // withState('address2Error', 'setAddress2Error', ''),
  withState('valueTab', 'setValueTab', 0),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowMenuPriceShashoku', 'setAllowMenuPriceShashoku', 0),
  withState('consent', 'setConsent', false),
  withState('consentStep2', 'setConsentStep2', false),
  withState('bankCode', 'setBankCode', ''),
  withState('bankCodeError', 'setBankCodeError', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('bankBranchCodeError', 'setBankBranchCodeError', ''),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('groupRegistrationId', 'setGroupRegistrationId', 'T'),
  withState('registrationIdError', 'setRegistrationIdError', ''),
  withState('paymentGroupId', 'setPaymentGroupId', null),
  withState('allowGapPayment', 'setAllowGapPayment', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
      this.props.setShopId(this.props.editInput.shopId);
      this.props.setShopName(this.props.editInput.shopName);
      this.props.setShopNameKana(this.props.editInput.shopNameKana);
      this.props.setCountryCode(this.props.editInput.countryCode);
      this.props.setZipCode(this.props.editInput.zipCode);
      this.props.setPrefectureCode(this.props.editInput.prefectureCode);
      this.props.setCity(this.props.editInput.city);
      this.props.setAddress(this.props.editInput.address);
      this.props.setAddress1(this.props.editInput.address1);
      this.props.setAddress2(this.props.editInput.address2);
      this.props.setBuilding(this.props.editInput.building);
      this.props.setShopGroupName(this.props.editInput.shopGroupName);
      this.props.setShopContactName(this.props.editInput.shopContactName);
      this.props.setDepartment(this.props.editInput.department);
      this.props.setContactPhone(this.props.editInput.contactPhone);
      this.props.setPhone(this.props.editInput.phone);
      this.props.setEmail(this.props.editInput.email);
      this.props.setIntroduction(this.props.editInput.introduction);
      this.props.setBusinessHours(this.props.editInput.businessHours);
      this.props.setHoliday(this.props.editInput.holiday);
      this.props.setNearestStation(this.props.editInput.nearestStation);
      this.props.setPriceRange(this.props.editInput.priceRange);
      this.props.setAccess(this.props.editInput.access);
      this.props.setWebPage(this.props.editInput.webPage);
      this.props.setTags(this.props.editInput.tags);
      this.props.setTagStr(this.props.editInput.tagStr);
      if (typeof this.props.editInput.images[0] !== 'undefined') {
        this.props.setPreviewImage1(this.props.editInput.images[0].image);
      }
      if (typeof this.props.editInput.images[1] !== 'undefined') {
        this.props.setPreviewImage2(this.props.editInput.images[1].image);
      }
      if (typeof this.props.editInput.images[2] !== 'undefined') {
        this.props.setPreviewImage3(this.props.editInput.images[2].image);
      }
      if (typeof this.props.editInput.images[3] !== 'undefined') {
        this.props.setPreviewImage4(this.props.editInput.images[3].image);
      }
      if (typeof this.props.editInput.images[4] !== 'undefined') {
        this.props.setPreviewImage5(this.props.editInput.images[4].image);
      }
      this.props.setStealthMode(this.props.editInput.stealthMode);
      this.props.setStealthModeStr(this.props.editInput.stealthModeStr);
      this.props.setGochiRestriction(this.props.editInput.gochiRestriction);
      this.props.setGochiRestrictionStr(
        this.props.editInput.gochiRestrictionStr
      );
      if (typeof this.props.editInput.accountStatus !== 'undefined') {
        this.props.setDepositManage(
          this.props.editInput.accountStatus.stripeAccount
            ? 'SELF'
            : this.props.editInput.depositManage
        );
        this.props.setDepositManageStr(
          this.props.editInput.accountStatus.stripeAccount
            ? 'Stripe経由で受取（週1回入金）'
            : this.props.editInput.depositManageStr
        );
      }
      this.props.setBankName(this.props.editInput.bankName);
      this.props.setBankBranchName(this.props.editInput.bankBranchName);
      this.props.setBankAccountType(
        this.props.editInput.bankAccountType === null
          ? 'SAVINGS'
          : this.props.editInput.bankAccountType
      );
      this.props.setBankAccountTypeStr(
        this.props.editInput.bankAccountTypeStr === null
          ? '普通預金'
          : this.props.editInput.bankAccountTypeStr
      );
      this.props.setBankAccountNumber(this.props.editInput.bankAccountNumber);
      this.props.setBankAccountHolder(this.props.editInput.bankAccountHolder);
      this.props.setStatus(this.props.editInput.status);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.setShopCategoryId(this.props.editInput.shopCategoryId);
      this.props.setNumberSit(this.props.editInput.numberSit);
      this.props.setParking(this.props.editInput.parking);
      this.props.setSmoking(this.props.editInput.smoking);
      this.props.setSnsFacebook(this.props.editInput.snsFacebook);
      this.props.setSnsTwitter(this.props.editInput.snsTwitter);
      this.props.setSnsInstagram(this.props.editInput.snsInstagram);
      this.props.setCashAllowed(this.props.editInput.cashAllowed);
      this.props.setBankCode(this.props.editInput.bankCode);
      this.props.setBankBranchCode(this.props.editInput.bankBranchCode);
      this.props.setAllowMenuPriceShashoku(
        this.props.editInput.shopDetail &&
          this.props.editInput.shopDetail.allowMenuPriceShashoku
      );
      this.props.setAllowGapPayment(
        this.props.editInput.shopDetail &&
          this.props.editInput.shopDetail.allowGapPayment
      );
      if (this.props.editInput.showPhone) {
        this.props.setShowPhone(1);
      } else {
        this.props.setShowPhone(0);
      }
      if (
        this.props.editInput.childShopFlag &&
        this.props.editInput.childShopFlag === 1
      ) {
        this.props.setChildShopFlag(1);
      } else {
        this.props.setChildShopFlag(0);
      }
      this.props.setPaymentGroupId(this.props.editInput.paymentGroupId);
      if (this.props.editInput.paymentGroupId) {
        this.props.setRegistrationId(this.props.editInput.registrationId);
        if (this.props.editInput.groupRegistrationId) {
          this.props.setHaveRegistrationId(1);
          this.props.setGroupRegistrationId(
            this.props.editInput.groupRegistrationId
          );
        } else {
          this.props.setHaveRegistrationId(0);
          this.props.setGroupRegistrationId(null);
        }
      } else {
        this.props.setGroupRegistrationId(null);
        if (this.props.editInput.registrationId) {
          this.props.setHaveRegistrationId(1);
          this.props.setRegistrationId(this.props.editInput.registrationId);
        } else {
          this.props.setHaveRegistrationId(0);
          this.props.setRegistrationId('T');
        }
      }
      const chosenCityNameList = [];
      this.props.cities
        .filter(
          item => item.cityName && item.cityName === this.props.editInput.city
        )
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });

      if (chosenCityNameList.length > 0) {
        this.props.setCityId(Number(chosenCityNameList[0].value));
      }

      let dataFirst = {};
      const origilData = {
        shopName: this.props.editInput.shopName,
        shopNameKana: this.props.editInput.shopNameKana,
        countryCode: this.props.editInput.countryCode,
        zipCode: this.props.editInput.zipCode,
        prefectureCode: this.props.editInput.prefectureCode,
        city: this.props.editInput.city,
        // address,
        address1: this.props.editInput.address1,
        address2: this.props.editInput.address2,
        // cityName,
        cityId:
          chosenCityNameList.length > 0
            ? Number(chosenCityNameList[0].value)
            : 0,
        building: this.props.editInput.building,
        shopGroupName: this.props.editInput.shopGroupName,
        shopContactName: this.props.editInput.shopContactName,
        department: this.props.editInput.department,
        contactPhone: this.props.editInput.contactPhone,
        phone: this.props.editInput.phone,
        email: this.props.editInput.email,
        introduction: this.props.editInput.introduction,
        businessHours: this.props.editInput.businessHours,
        holiday: this.props.editInput.holiday,
        nearestStation: this.props.editInput.nearestStation,
        // setNearestStation,
        priceRange: this.props.editInput.priceRange,
        access: this.props.editInput.access,
        webPage: this.props.editInput.webPage,
        tags: this.props.editInput.tags,
        stealthMode: this.props.editInput.stealthMode,
        gochiRestriction: this.props.editInput.gochiRestriction,
        depositManage: this.props.editInput.accountStatus.stripeAccount
          ? 'SELF'
          : this.props.editInput.depositManage,
        bankAccount: {
          bankName: this.props.editInput.bankName,
          bankBranchName: this.props.editInput.bankBranchName,
          bankAccountType:
            this.props.editInput.bankAccountType === null
              ? 'SAVINGS'
              : this.props.editInput.bankAccountType,
          bankAccountNumber: this.props.editInput.bankAccountNumber,
          bankAccountHolder: this.props.editInput.bankAccountHolder
        },
        status: this.props.editInput.status,
        updatedAt: this.props.editInput.updatedAt,
        shopCategoryId: this.props.editInput.shopCategoryId,
        numberSit: this.props.editInput.numberSit,
        smoking: this.props.editInput.smoking,
        parking: this.props.editInput.parking,
        snsFacebook: this.props.editInput.snsFacebook,
        snsTwitter: this.props.editInput.snsTwitter,
        snsInstagram: this.props.editInput.snsInstagram,
        showPhone: this.props.editInput.showPhone ? 1 : 0,
        childShopFlag:
          this.props.editInput.childShopFlag &&
          this.props.editInput.childShopFlag === 1
            ? 1
            : 0,
        cashAllowed: this.props.editInput.cashAllowed,
        allowGapPayment: this.props.editInput.allowGapPayment
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        }
        if (
          this.props.editInput.otherLanguages &&
          this.props.editInput.otherLanguages.length > 0
        ) {
          this.props.editInput.otherLanguages.forEach(ob => {
            if (item.value === ob.language) {
              const other = {
                translateType: ob.translateType ? ob.translateType : 0,
                language: item.value,
                params: {
                  shopName: ob.params.shopName,
                  shopNameKana: ob.params.shopNameKana,
                  address1: ob.params.address1,
                  address2: ob.params.address2,
                  building: ob.params.building,
                  shopGroupName: ob.params.shopGroupName,
                  shopContactName: ob.params.shopContactName,
                  department: ob.params.department,
                  introduction: ob.params.introduction,
                  businessHours: ob.params.businessHours,
                  holiday: ob.params.holiday,
                  nearestStation: ob.params.nearestStation,
                  access: ob.params.access,
                  numberSit: ob.params.numberSit,
                  smoking: ob.params.smoking,
                  parking: ob.params.parking
                }
              };
              arr.push(other);
            }
          });
          const found = this.props.editInput.otherLanguages.find(
            e => e.language === item.value && item.value !== languageType.ORIGIN
          );
          if (!found) {
            const other = {
              translateType: 0,
              language: item.value
            };
            arr.push(other);
          }
        }
      });
      if (
        !this.props.editInput.otherLanguages ||
        (this.props.editInput.otherLanguages &&
          this.props.editInput.otherLanguages.length <= 0)
      ) {
        languages.forEach(ob => {
          const other = {
            translateType: 0,
            language: ob.value
          };
          arr.push(other);
        });
      }
      dataFirst.otherLanguages = arr.filter(
        i => i.language !== languageType.ORIGIN
      );
      this.props.setMultiLangData(dataFirst);
      console.log('dataFirst', dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    searchKey,
    editInput,
    prefectures,
    openEditConfirm,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    shopId,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    countryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    // address,
    // setAddress,
    address1,
    setAddress1,
    address2,
    // setAddress2,
    cityId,
    setCityId,
    // cityName,
    // setCityName,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    email,
    setEmail,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    tagStr,
    setTagStr,
    tags,
    setTags,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    image2,
    setImage2,
    previewImage2,
    setPreviewImage2,
    image3,
    setImage3,
    previewImage3,
    setPreviewImage3,
    image4,
    setImage4,
    previewImage4,
    setPreviewImage4,
    image5,
    setImage5,
    previewImage5,
    setPreviewImage5,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    status,
    updatedAt,
    updateOpenEditModal,
    shopCategories,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    setSnsTwitter,
    snsTwitter,
    setSnsInstagram,
    snsInstagram,
    shopNameError,
    setShopNameError,
    shopNameKanaError,
    setShopNameKanaError,
    zipCodeError,
    setZipCodeError,
    cityError,
    // setCityError,
    // addressError,
    // setAddressError,
    // cityError,
    // setCityError,
    cityIdError,
    setCityIdError,
    contactPhoneError,
    setContactPhoneError,
    phoneError,
    setPhoneError,
    emailError,
    setEmailError,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    shopCategoriesError,
    setShopCategoriesError,
    snsFacebookError,
    setSnsFacebookError,
    snsTwitterError,
    setSnsTwitterError,
    snsInstagramError,
    setSnsInstagramError,
    shopContactNameError,
    shopGroupNameError,
    departmentError,
    setShopContactNameError,
    setShopGroupNameError,
    setDepartmentError,
    showPhone,
    // setShowPhone,
    childShopFlag,
    // setChildShopFlag
    address1Error,
    setAddress1Error,
    // address2Error,
    // setAddress2Error,
    valueTab,
    setValueTab,
    handleChangePage,
    multiLangData,
    setMultiLangData,
    isLanguage,
    setIsLanguage,
    translateType,
    setTranslateType,
    cashAllowed,
    // setCashAllowed,
    allowMenuPriceShashoku,
    setAllowMenuPriceShashoku,
    isFukuoka,
    bankCode,
    setBankCode,
    bankCodeError,
    setBankCodeError,
    listBank,
    bankBranchCode,
    setBankBranchCode,
    bankBranchCodeError,
    setBankBranchCodeError,
    listBankBranch,
    haveRegistrationId,
    setHaveRegistrationId,
    registrationId,
    setRegistrationId,
    registrationIdError,
    setRegistrationIdError,
    paymentGroupId,
    groupRegistrationId,
    educateSystem,
    allowGapPayment,
    setAllowGapPayment
  }) => {
    const editConfirm = {
      ...multiLangData,
      tagStr,
      stealthModeStr,
      gochiRestrictionStr,
      depositManageStr,
      bankAccountTypeStr,
      previewImage1,
      previewImage2,
      previewImage3,
      previewImage4,
      previewImage5,
      bankAccountNumber,
      bankName,
      bankBranchName,
      bankAccountHolder,
      cashAllowed,
      allowMenuPriceShashoku,
      bankCode,
      bankBranchCode,
      registrationId,
      groupRegistrationId,
      haveRegistrationId,
      paymentGroupId,
      allowGapPayment
    };
    // const editConfirm = {
    //   shopName,
    //   shopNameKana,
    //   zipCode,
    //   prefectureCode,
    //   city,
    //   // address,
    //   address1,
    //   address2,
    //   // cityName,
    //   building,
    //   shopGroupName,
    //   shopContactName,
    //   department,
    //   contactPhone,
    //   phone,
    //   email,
    //   introduction,
    //   businessHours,
    //   holiday,
    //   nearestStation,
    //   setNearestStation,
    //   priceRange,
    //   access,
    //   webPage,
    //   tagStr,
    //   previewImage1,
    //   previewImage2,
    //   previewImage3,
    //   previewImage4,
    //   previewImage5,
    //   stealthModeStr,
    //   gochiRestrictionStr,
    //   depositManage,
    //   depositManageStr,
    //   bankName,
    //   bankBranchName,
    //   bankAccountTypeStr,
    //   bankAccountNumber,
    //   bankAccountHolder,
    //   status,
    //   shopCategoryId,
    //   numberSit,
    //   smoking,
    //   parking,
    //   snsFacebook,
    //   snsTwitter,
    //   snsInstagram,
    //   showPhone,
    //   childShopFlag
    // };
    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder,
      bankCode,
      bankBranchCode
    };
    // const editParam = {
    //   shopName,
    //   shopNameKana,
    //   countryCode,
    //   zipCode,
    //   prefectureCode,
    //   city,
    //   // address,
    //   address1,
    //   address2,
    //   // cityName,
    //   cityId,
    //   building,
    //   shopGroupName,
    //   shopContactName,
    //   department,
    //   contactPhone,
    //   phone,
    //   email,
    //   introduction,
    //   businessHours,
    //   holiday,
    //   nearestStation,
    //   setNearestStation,
    //   priceRange,
    //   access,
    //   webPage,
    //   tags,
    //   stealthMode,
    //   gochiRestriction,
    //   depositManage,
    //   bankAccount,
    //   status,
    //   updatedAt,
    //   shopCategoryId,
    //   numberSit,
    //   smoking,
    //   parking,
    //   snsFacebook,
    //   snsTwitter,
    //   snsInstagram,
    //   showPhone,
    //   childShopFlag
    // };

    const errors = {
      shopNameError,
      shopNameKanaError,
      zipCodeError,
      cityError,
      // addressError,
      address1Error,
      // address2Error,
      // cityError,
      cityIdError,
      contactPhoneError,
      phoneError,
      emailError,
      bankNameError,
      bankBranchNameError,
      bankAccountNumberError,
      bankAccountHolderError,
      shopCategoriesError,
      snsFacebookError,
      snsTwitterError,
      snsInstagramError,
      shopContactNameError,
      shopGroupNameError,
      departmentError,
      bankCodeError,
      bankBranchCodeError,
      registrationIdError
    };
    const enableShopBank =
      editInput.bankSwitchable || !editInput.paymentGroupType;

    const checkCityName = () => {
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    const cityIdCheck = checkCityName();

    if (cityIdCheck > 0) {
      useEffect(() => {
        setCityId(checkCityName());
      }, [city]);
    }

    const setNewCityId = newCity => {
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === newCity)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        setCityId(Number(chosenCityNameList[0].value));
      }
    };

    const getZipCodeData = async zipcode => {
      await actions.getZipCode(zipcode).then(data => {
        setPrefectureCode(data.payload.prefectureCode);
        setCity(data.payload.city ? data.payload.city : 0);
        // setAddress(data.payload.address ? data.payload.address : '');
        setAddress1(data.payload.address1 ? data.payload.address1 : '');
        // setAddress2(data.payload.address2 ? data.payload.address2 : '');
        setNewCityId(data.payload.city);
      });
    };

    const validShopName = () => {
      const value = shopName;
      if (value.trim() === '') {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopName(value);
      return 0;
    };
    const validShopNameKana = () => {
      const value = shopNameKana;
      if (value.trim() === '') {
        setShopNameKanaError('必須項目です。');
        return 1;
      }
      if (
        !/^[\u3040-\u309F\s\d０-９ー]+$/.test(value) &&
        isLanguage === languageType.ORIGIN
      ) {
        setShopNameKanaError('ひらがなで入力してください。');
        return 1;
      }
      setShopNameKanaError('');
      setShopNameKana(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    const validShopCategories = () => {
      const value = shopCategoryId;
      if (value === 0) {
        setShopCategoriesError('必須項目です。');
        return 1;
      }
      setShopCategoriesError('');
      setShopCategoryId(value);
      return 0;
    };
    const validSnsFacebook = () => {
      const value = snsFacebook;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsFacebookError('URLを入力してください');
        return 1;
      }
      setSnsFacebookError('');
      setSnsFacebook(value);
      return 0;
    };
    const validSnsTwitter = () => {
      const value = snsTwitter;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsTwitterError('URLを入力してください');
        return 1;
      }
      setSnsTwitterError('');
      setSnsTwitter(value);
      return 0;
    };
    const validSnsInstagram = () => {
      const value = snsInstagram;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsInstagramError('URLを入力してください');
        return 1;
      }
      setSnsInstagramError('');
      setSnsInstagram(value);
      return 0;
    };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };
    // const validAddress = () => {
    //   const value = address ? address.trim() : '';
    //   if (value === '') {
    //     setAddressError('必須項目です。');
    //     return 1;
    //   }
    //   setAddressError('');
    //   setAddress(value);
    //   return 0;
    // };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validAddress1 = () => {
      const value = address1 ? address1.trim() : '';
      if (value === '') {
        setAddress1Error('必須項目です。');
        return 1;
      }
      setAddress1Error('');
      setAddress1(value);
      return 0;
    };
    // const validAddress2 = () => {
    //  const value = address2 ? address2.trim() : '';
    //  if (value === '') {
    //    setAddress2Error('必須項目です。');
    //    return 1;
    //  }
    //  setAddress2Error('');
    //  setAddress2(value);
    //  return 0;
    // };
    const validShopContactName = () => {
      const value = shopContactName ? shopContactName.trim() : '';
      if (value.trim() === '') {
        setShopContactNameError('必須項目です。');
        return 1;
      }
      setShopContactNameError('');
      setShopContactName(value);
      return 0;
    };
    const validShopGroupName = () => {
      const value = shopGroupName ? shopGroupName.trim() : '';
      if (value.trim() === '') {
        setShopGroupNameError('必須項目です。');
        return 1;
      }
      setShopGroupNameError('');
      setShopGroupName(value);
      return 0;
    };
    const validDepartment = () => {
      const value = department ? department.trim() : '';
      if (value.trim() === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };
    const validContactPhone = () => {
      const value = contactPhone;
      if (value === '') {
        setContactPhoneError('必須項目です。');
        return 1;
      }
      if (value && !/^\d+$/.test(value)) {
        setContactPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setContactPhoneError('');
      setContactPhone(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone;
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validEmail = () => {
      const value = email;
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validEmailCount = emailData => {
      const value = email;
      if (
        emailData.payload.totalCount > 0 &&
        editInput.email !== emailData.payload.shops[0].email
      ) {
        setEmailError('メールアドレスが既に登録されています。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validBankName = () => {
      const value = bankName;
      if (enableShopBank && depositManage === 'NONSELF' && !value) {
        setBankNameError('必須項目です。');
        return 1;
      }
      setBankNameError('');
      setBankName(value);
      return 0;
    };
    const validBankBranchName = () => {
      const value = bankBranchName;
      if (enableShopBank && depositManage === 'NONSELF' && !value) {
        setBankBranchNameError('必須項目です。');
        return 1;
      }
      setBankBranchNameError('');
      setBankBranchName(value);
      return 0;
    };
    const validBankAccountNumber = () => {
      const value = bankAccountNumber;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };
    const validBankAccountHolder = () => {
      const value = bankAccountHolder;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };
    const getBankName = bankCodeValue => {
      let listBankName = [];
      listBankName = listBank.filter(bank => bank.bankCode === bankCodeValue);
      if (listBankName.length === 0) {
        setBankCodeError('データが正しくありません。');
        setBankName('');
        return false;
      }
      setBankName(listBankName[0].bankName);
      return true;
    };

    const getBankBranchName = bankBranchCodeValue => {
      let listBankBranchName = [];
      listBankBranchName = listBankBranch.filter(
        bankBranch => bankBranch.uniqueCode === bankCode + bankBranchCodeValue
      );
      if (listBankBranchName.length === 0) {
        setBankBranchCodeError('データが正しくありません。');
        setBankBranchName('');
        return false;
      }
      setBankBranchName(listBankBranchName[0].bankBranchName);
      return true;
    };

    const validBankCode = () => {
      const value = bankCode;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 4) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankName(value)) {
          return 1;
        }
      }
      setBankCodeError('');
      return 0;
    };

    const validBankBranchCode = () => {
      const value = bankBranchCode;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankBranchCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 3) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankBranchName(value)) {
          return 1;
        }
      }
      setBankBranchCodeError('');
      return 0;
    };
    // const convertShowPhone = checked => {
    //   if (checked) {
    //     setShowPhone(0);
    //   } else {
    //     setShowPhone(1);
    //   }
    // };
    // const convertChildShopFlag = checked => {
    //   if (checked) {
    //     setChildShopFlag(1);
    //   } else {
    //     setChildShopFlag(0);
    //   }
    // };

    const validRegistrationId = () => {
      const value = registrationId;
      if (isFukuoka || paymentGroupId) {
        return 0;
      }
      if (haveRegistrationId === 1) {
        const valueNumber = value.slice(1);
        if (!value || !valueNumber) {
          setRegistrationIdError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(valueNumber)) {
          setRegistrationIdError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueNumber.length !== 13) {
          setRegistrationIdError('13桁の番号をご入力ください。');
          return 1;
        }
      }
      setRegistrationId(value);
      setRegistrationIdError('');
      return 0;
    };

    const valid = emailData => {
      const errorCount =
        validShopName() +
        validShopNameKana() +
        validCityId() +
        validZipCodeSubmit() +
        // validCity() +
        // validAddress() +
        validAddress1() +
        // validAddress2() +
        validContactPhone() +
        validPhone() +
        validEmail() +
        validEmailCount(emailData) +
        validBankName() +
        validBankBranchName() +
        validBankAccountNumber() +
        validBankAccountHolder() +
        validShopCategories() +
        validSnsFacebook() +
        validSnsTwitter() +
        validSnsInstagram() +
        validShopContactName() +
        validShopGroupName() +
        validDepartment() +
        validBankCode() +
        validBankBranchCode() +
        validRegistrationId();

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const validLang = () => {
      const errorCount =
        validShopName() +
        validShopNameKana() +
        validCityId() +
        validZipCodeSubmit() +
        // validCity() +
        // validAddress() +
        validAddress1() +
        // validAddress2() +
        validContactPhone() +
        validPhone() +
        validEmail() +
        validBankName() +
        validBankBranchName() +
        validBankAccountNumber() +
        validBankAccountHolder() +
        validShopCategories() +
        validSnsFacebook() +
        validSnsTwitter() +
        validSnsInstagram() +
        validShopContactName() +
        validShopGroupName() +
        validDepartment() +
        validBankCode() +
        validBankBranchCode();

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          imagePath: previewImage1
        },
        1: {
          image: image2,
          imagePath: previewImage2
        },
        2: {
          image: image3,
          imagePath: previewImage3
        },
        3: {
          image: image4,
          imagePath: previewImage4
        },
        4: {
          image: image5,
          imagePath: previewImage5
        }
      };
      return imageArray;
    };
    const convertStealthModeStr = mode => {
      if (mode === 'UNSTEALTH') {
        setStealthModeStr('表示');
      } else {
        setStealthModeStr('非表示');
      }
    };
    const convertGochiRestrictionStr = mode => {
      if (mode === 'MENTION_ONLY') {
        setGochiRestrictionStr('指名ごちのみ');
      } else {
        setGochiRestrictionStr('制限なし');
      }
    };
    const convertDepositManageStr = mode => {
      if (mode === 'SELF') {
        setDepositManageStr('Stripe経由で受取（週1回入金）');
      } else {
        setDepositManageStr('銀行口座で直接受取（月1回入金）（オプション）');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        shopName,
        shopNameKana,
        countryCode,
        zipCode,
        prefectureCode,
        city,
        // address,
        address1,
        address2,
        // cityName,
        cityId,
        building,
        shopGroupName,
        shopContactName,
        department,
        contactPhone,
        phone,
        email,
        introduction,
        businessHours,
        holiday,
        nearestStation,
        setNearestStation,
        priceRange,
        access,
        webPage,
        tags,
        stealthMode,
        gochiRestriction,
        depositManage,
        bankAccount,
        status,
        updatedAt,
        shopCategoryId,
        numberSit,
        smoking,
        parking,
        snsFacebook,
        snsTwitter,
        snsInstagram,
        showPhone,
        childShopFlag,
        cashAllowed,
        shopDetail: {
          shopDetailId:
            editInput.shopDetail && editInput.shopDetail.shopDetailId,
          allowMenuPriceShashoku,
          allowGapPayment
        },
        isShopCanEditSetting: editInput.isShopCanEditSetting,
        registrationId:
          haveRegistrationId || paymentGroupId ? registrationId : undefined
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          shopName,
          shopNameKana,
          // address1,
          // address2,
          // building,
          shopGroupName,
          shopContactName,
          department,
          introduction,
          businessHours,
          holiday,
          nearestStation,
          access,
          numberSit,
          smoking,
          parking
        }
      };
      // origin lang
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other lang
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      return JSON.stringify(data);
    };
    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          console.log('multiLangData', JSON.stringify(multiLangData));
          if (multiLangData.otherLanguages[k].language === v) {
            setShopName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopName
                ? multiLangData.otherLanguages[k].params.shopName
                : ''
            );
            setShopNameKana(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopNameKana
                ? multiLangData.otherLanguages[k].params.shopNameKana
                : ''
            );
            // setAddress1(
            //   multiLangData.otherLanguages[k].params &&
            //     multiLangData.otherLanguages[k].params.address1
            //     ? multiLangData.otherLanguages[k].params.address1
            //     : ''
            // );
            // setAddress2(
            //   multiLangData.otherLanguages[k].params &&
            //     multiLangData.otherLanguages[k].params.address2
            //     ? multiLangData.otherLanguages[k].params.address2
            //     : ''
            // );
            // setBuilding(
            //   multiLangData.otherLanguages[k].params &&
            //     multiLangData.otherLanguages[k].params.building
            //     ? multiLangData.otherLanguages[k].params.building
            //     : ''
            // );
            setShopGroupName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopGroupName
                ? multiLangData.otherLanguages[k].params.shopGroupName
                : ''
            );
            setShopContactName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.shopContactName
                ? multiLangData.otherLanguages[k].params.shopContactName
                : ''
            );
            setDepartment(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.department
                ? multiLangData.otherLanguages[k].params.department
                : ''
            );
            setIntroduction(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.introduction
                ? multiLangData.otherLanguages[k].params.introduction
                : ''
            );
            setBusinessHours(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.businessHours
                ? multiLangData.otherLanguages[k].params.businessHours
                : ''
            );
            setHoliday(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.holiday
                ? multiLangData.otherLanguages[k].params.holiday
                : ''
            );
            setNearestStation(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.nearestStation
                ? multiLangData.otherLanguages[k].params.nearestStation
                : ''
            );
            setAccess(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.access
                ? multiLangData.otherLanguages[k].params.access
                : ''
            );
            setNumberSit(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.numberSit
                ? multiLangData.otherLanguages[k].params.numberSit
                : ''
            );
            setSmoking(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.smoking
                ? multiLangData.otherLanguages[k].params.smoking
                : ''
            );
            setParking(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.parking
                ? multiLangData.otherLanguages[k].params.parking
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setShopName(multiLangData.shopName);
        setShopNameKana(multiLangData.shopNameKana);
        // setAddress1(multiLangData.address1);
        // setAddress2(multiLangData.address2);
        // setBuilding(multiLangData.building);
        setShopGroupName(multiLangData.shopGroupName);
        setShopContactName(multiLangData.shopContactName);
        setDepartment(multiLangData.department);
        setIntroduction(multiLangData.introduction);
        setBusinessHours(multiLangData.businessHours);
        setHoliday(multiLangData.holiday);
        setNearestStation(multiLangData.nearestStation);
        setAccess(multiLangData.access);
        setNumberSit(multiLangData.numberSit);
        setSmoking(multiLangData.smoking);
        setParking(multiLangData.parking);
      }
      setIsLanguage(v);
      setMultiLangData(JSON.parse(data));
      console.log('loc', JSON.parse(data));
    };

    const cancelAction = () => updateOpenEditModal(false);
    const confirmAction = async () => {
      setMultiLangData(JSON.parse(getCurrentData()));
      const emailData = await actions
        .countShopEmail(email)
        .then(data => checkSession(data));
      if (
        isLanguage === languageType.ORIGIN ||
        (isLanguage !== languageType.ORIGIN && translateType === 1)
      ) {
        if (!valid(emailData)) {
          alert('登録情報を正しく入力してください。');
        } else {
          updateLoading(false);
          setCityNameData(cityId);
          updateOpenEditConfirm(true);
        }
      } else {
        updateLoading(false);
        setCityNameData(cityId);
        updateOpenEditConfirm(true);
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const images = convertImages();
      const editedShop = await actions
        .editShop(shopId, multiLangData)
        .then(data => checkSession(data));
      const imagePaths = await Promise.all(
        Object.keys(images).map(async i => {
          if (images[i].image !== null) {
            let { image } = images[i];
            if (image.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
              const { resizeImageFile } = await resizeImage(image);
              image = resizeImageFile;
            }
            const imagePath = await uploadFile('shop', shopId, image, 'public');
            return imagePath;
          }
          if (images[i].imagePath !== null) {
            return images[i].imagePath;
          }
          return null;
        })
      );
      const addImages = imagePaths
        .filter(i => i !== null)
        .map((i, index) => {
          return { image: i, viewOrder: index };
        });
      if (Object.keys(addImages).length !== 0) {
        await actions
          .addShopImage(shopId, {
            images: addImages
          })
          .then(data => checkSession(data));
      }
      if (editedShop.type === 'EDIT_SHOP_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getShops(searchKey).then(data => {
          actions.getAccounts({ cognitoUserId: '' });
          checkSession(data);
        });
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        if (editedShop.payload.status && editedShop.payload.status === 409) {
          setResultMessage(
            'こども食堂用（単独）が存在していますのでこども食堂の設定が外せません。'
          );
        } else {
          setResultMessage('編集に失敗しました。');
        }
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEditModal(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
        handleChangePage(null, 1, 10);
      } else {
        updateOpenEditProgress(false);
      }
    };

    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };
    const handleChange = (event, newValue) => {
      setValueTab(newValue);
    };

    const handleChangeBankCode = value => {
      setBankCode(value);
      setBankName('');
      setBankBranchCode('');
      setBankBranchName('');
    };

    const getLinkSupportEducation = educate => {
      let url =
        'https://kodomonaraigoto-fukuoka.jp/category-classroom/about-registration-application#edit-registration';

      if (educate === nameSystem.nishiwaki) {
        url =
          'https://kodomomirai-nishiwaki.jp/category-classroom/about-registration-application';
      }

      return url;
    };

    return (
      <>
        <Paper className={classes.root} id="scrollTableAdd">
          <div className={classes.langDiv}>
            <ReactSelectMaterialUi
              required
              className={[classes.tableCell90, classes.textField]}
              defaultValue={isLanguage}
              value={isLanguage}
              options={languages}
              margin="normal"
              onChange={v => {
                if (
                  validLang() ||
                  (isLanguage !== languageType.ORIGIN && translateType === 0)
                ) {
                  setLanguage(v);
                } else {
                  alert('登録情報を正しく入力してください。');
                }
              }}
            />
            {isLanguage !== languageType.ORIGIN && (
              <Typography component="div" className={classes.formInput}>
                <RadioGroup
                  value={translateType}
                  onChange={e => {
                    console.log('e', e.target.value);
                    setTranslateType(parseInt(e.target.value, 10));
                  }}
                >
                  <FormControlLabel
                    value={0}
                    control={<Radio color="primary" />}
                    label="GG翻訳を選択"
                  />
                  <FormControlLabel
                    value={1}
                    control={<Radio color="primary" />}
                    label="自分で文書入力"
                  />
                </RadioGroup>
              </Typography>
            )}
          </div>
          <Tabs
            value={valueTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered={!isFukuoka}
            className={classes.tabpanelHeader}
          >
            <Tab
              label="基本情報（必須）"
              className={classNames(
                classes.btnTabpanel,
                valueTab === 0 && classes.tabSelected
              )}
            />
            <Tab
              label="その他（任意）"
              className={classNames(
                classes.btnTabpanel,
                valueTab === 1 && classes.tabSelected
              )}
            />
            {!isFukuoka && (
              <Tab
                label="高度な設定（任意）"
                className={classNames(
                  classes.btnTabpanel,
                  valueTab === 2 && classes.tabSelected
                )}
              />
            )}
          </Tabs>

          <TabPanelDetail value={valueTab} index={0}>
            <Table className={classes.editTable}>
              <TableBody>
                {isFukuoka && educateSystem !== nameSystem.suita && (
                  <TableRow>
                    <TableCell className={[classes.colRight, classes.pb0]}>
                      <Text className={[classes.textRed, classes.fw700]}>
                        必須項目は変更できません。
                      </Text>
                      <div className={classes.textBlack}>
                        ※申請内容に変更がある場合は、
                        <Link
                          href={getLinkSupportEducation(educateSystem)}
                          target="_blank"
                          className={[classes.link, classes.textBlack]}
                        >
                          {getTextBySystem(
                            '福岡市子ども習い事応援事業専用サイト',
                            educateSystem
                          )}
                        </Link>
                        より「変更届」をダウンロードして必要事項を記入し、運営事務局宛に送付してください。
                      </div>
                    </TableCell>
                  </TableRow>
                )}
                <TableRow className={classes.borderBottom}>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={[classes.colRight]}>
                    <TextField
                      required
                      label={isFukuoka ? '教室名' : '店舗名'}
                      defaultValue={editInput.shopName}
                      value={shopName}
                      placeholder={isFukuoka ? '' : 'ごち屋　天神店'}
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0) ||
                        (isFukuoka && educateSystem !== nameSystem.suita)
                      }
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 1000 : 2500
                      }}
                      onChange={e => {
                        setShopName(e.target.value);
                      }}
                      onBlur={validShopName}
                    />
                    <ValidationText message={errors.shopNameError} />
                  </TableCell>
                </TableRow>
                <TableRow className={classes.borderBottom}>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      required
                      label={isFukuoka ? '教室名かな' : '店舗名かな'}
                      defaultValue={editInput.shopNameKana}
                      value={shopNameKana}
                      placeholder={isFukuoka ? '' : 'ごちや　てんじんてん'}
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0) ||
                        (isFukuoka && educateSystem !== nameSystem.suita)
                      }
                      onChange={e => {
                        setShopNameKana(e.target.value);
                      }}
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 1000 : 2500
                      }}
                      onBlur={validShopNameKana}
                    />
                    <ValidationText message={errors.shopNameKanaError} />
                  </TableCell>
                </TableRow>
                {isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow className={classes.groupBorderNone}>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colLeft
                        ]}
                      >
                        <RequiredButton />
                      </TableCell>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                      >
                        <TextField
                          required
                          label="郵便番号"
                          defaultValue={editInput.zipCode}
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setZipCode(e.target.value);
                          }}
                          onBlur={validZipCode}
                          disabled={
                            isFukuoka && educateSystem !== nameSystem.suita
                          }
                        />
                        <Typography variant="h7">
                          ハイフンなしで記載ください
                        </Typography>
                        <ValidationText message={errors.zipCodeError} />
                      </TableCell>
                    </TableRow>
                    <TableRow className={classes.tableRowBorderNone}>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                      >
                        <TextField
                          required
                          select
                          label="都道府県"
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          value={prefectureCode}
                          onChange={e => {
                            setPrefectureCode(e.target.value);
                            setCityId(Number(0));
                            setCityNameData(0);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          disabled={
                            isFukuoka && educateSystem !== nameSystem.suita
                          }
                        >
                          {prefectures.map(item => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                      >
                        {prefectureCode > 0 && (
                          <ReactSelectMaterialUi
                            required
                            label="市区町村*"
                            fullWidth
                            className={classes.textField}
                            // defaultValue={String(checkCityName())}
                            defaultValue={String(cityId)}
                            value={String(cityId)}
                            options={getCitiesOptions()}
                            margin="normal"
                            onChange={e => {
                              setCityId(Number(e));
                              setCityNameData(Number(e));
                            }}
                            SelectProps={{
                              isClearable: true,
                              msgNoOptionsMatchFilter:
                                '名前が部分一致する店舗がありません'
                            }}
                            onBlur={validCityId}
                            disabled={
                              isFukuoka && educateSystem !== nameSystem.suita
                            }
                          />
                        )}
                        {editInput.city && !cityId && checkCityName() <= 0 && (
                          <Typography variant="h7">
                            市区町村はまだ正規化されません。再度設定してください。
                          </Typography>
                        )}
                        {(!prefectureCode || prefectureCode <= 0) && (
                          <ReactSelectMaterialUi
                            disabled
                            required
                            fullWidth
                            label="市区町村*"
                            className={classes.textField}
                            defaultValue={String(checkCityName())}
                            value={String(cityId)}
                            options={getCitiesOptions()}
                            margin="normal"
                            onChange={e => {
                              setCityId(Number(e));
                              setCityNameData(Number(e));
                            }}
                            SelectProps={{
                              isClearable: true,
                              msgNoOptionsMatchFilter:
                                '名前が部分一致する店舗がありません'
                            }}
                            onBlur={validCityId}
                          />
                        )}
                        <ValidationText message={errors.cityIdError} />
                      </TableCell>
                    </TableRow>
                  </>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        required
                        label="町域・番地"
                        placeholder="天神"
                        defaultValue={editInput.address1}
                        value={address1}
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        disabled={
                          (isLanguage !== languageType.ORIGIN &&
                            translateType === 0) ||
                          (isFukuoka && educateSystem !== nameSystem.suita)
                        }
                        onChange={e => {
                          setAddress1(e.target.value);
                        }}
                        onBlur={validAddress1}
                      />
                      <ValidationText message={errors.address1Error} />
                    </TableCell>
                  </TableRow>
                )}
                {/* {isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        required
                        label="番地"
                        placeholder="1-2-3"
                        defaultValue={editInput.address2}
                        value={address2}
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        disabled={
                          isLanguage !== languageType.ORIGIN &&
                          translateType === 0
                        }
                        onChange={e => {
                          setAddress2(e.target.value);
                        }}
                        onBlur={validAddress2}
                      />
                      <ValidationText message={errors.address2Error} />
                    </TableCell>
                  </TableRow>
                )} */}
                {isLanguage === languageType.ORIGIN && (
                  <TableRow className={classes.borderBottom}>
                    <TableCell className={classes.colRight}>
                      <TextField
                        label="建物名"
                        defaultValue={editInput.building}
                        value={building}
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        disabled={
                          (isLanguage !== languageType.ORIGIN &&
                            translateType === 0) ||
                          (isFukuoka && educateSystem !== nameSystem.suita)
                        }
                        onChange={e => {
                          setBuilding(e.target.value);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && !isFukuoka && (
                  <>
                    <TableRow className={classes.borderBottom}>
                      <TableCell className={classes.colLeft}>
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <TextField
                          required
                          select
                          label="店舗カテゴリー"
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          value={shopCategoryId}
                          onChange={e => {
                            setShopCategoryId(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        >
                          {shopCategories.map(item => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.colRight,
                      classes.fs12
                    ]}
                  >
                    {!isFukuoka && (
                      <>
                        店舗オーナーさまへの依頼）
                        <br />
                        店舗オーナーさまが登録された店舗の現場に連絡しても、
                        「ごちめし」のことを全く知らないという事例が発生してきています。
                        店舗登録時には現場の責任者に了解を取った後に登録ください。
                      </>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.colRight,
                      classes.fs12
                    ]}
                  >
                    <TextField
                      required
                      label="運営会社名"
                      defaultValue={editInput.shopGroupName}
                      value={shopGroupName}
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0) ||
                        (isFukuoka && educateSystem !== nameSystem.suita)
                      }
                      inputProps={{
                        maxLength: 500
                      }}
                      onChange={e => {
                        setShopGroupName(e.target.value);
                      }}
                      onBlur={validShopGroupName}
                    />
                    <Typography variant="h7">
                      {isFukuoka
                        ? '個人事業主の場合は「なし」と記載ください'
                        : '個人店の場合は「なし」と記載ください'}
                    </Typography>
                    <ValidationText message={errors.shopGroupNameError} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      required
                      label="ご担当者名"
                      defaultValue={editInput.shopContactName}
                      value={shopContactName}
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      inputProps={{
                        maxLength: 500
                      }}
                      disabled={
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0) ||
                        (isFukuoka && educateSystem !== nameSystem.suita)
                      }
                      onChange={e => {
                        setShopContactName(e.target.value);
                      }}
                      onBlur={validShopContactName}
                    />
                    <ValidationText message={errors.shopContactNameError} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      required
                      label="所属部署"
                      defaultValue={editInput.department}
                      value={department}
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      inputProps={{
                        maxLength: 500
                      }}
                      disabled={
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0) ||
                        (isFukuoka && educateSystem !== nameSystem.suita)
                      }
                      onChange={e => {
                        setDepartment(e.target.value);
                      }}
                      onBlur={validDepartment}
                    />
                    <Typography variant="h7">
                      {isFukuoka
                        ? '個人事業主の場合は「なし」と記載ください'
                        : '個人店の場合は「なし」と記載ください'}
                    </Typography>
                    <ValidationText message={errors.departmentError} />
                  </TableCell>
                </TableRow>
                {isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow className={classes.borderBottom}>
                      <TableCell className={classes.colRight}>
                        <TextField
                          required
                          label="電話番号（担当者）"
                          defaultValue={editInput.contactPhone}
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setContactPhone(e.target.value);
                          }}
                          onBlur={validContactPhone}
                          disabled={
                            isFukuoka && educateSystem !== nameSystem.suita
                          }
                        />
                        <Typography variant="h7">
                          ハイフンなしで記載ください
                        </Typography>
                        <ValidationText message={errors.contactPhoneError} />
                      </TableCell>
                    </TableRow>
                    <TableRow className={classes.borderBottom}>
                      <TableCell className={classes.colLeft}>
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <TextField
                          required
                          label={isFukuoka ? '教室電話番号' : '店舗電話番号'}
                          defaultValue={editInput.phone}
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setPhone(e.target.value);
                          }}
                          onBlur={validPhone}
                          disabled={
                            isFukuoka && educateSystem !== nameSystem.suita
                          }
                        />
                        <Typography variant="h7">
                          ハイフンなしで記載ください
                        </Typography>
                        {/* <Fragment>
                      <br />
                      <FormControlLabel
                        checked={!showPhone}
                        control={<Checkbox id="showPhone" color="primary" />}
                        label="電話番号を非表示します。"
                        value={showPhone}
                        onChange={e => {
                          setShowPhone(e.target.checked);
                          convertShowPhone(e.target.checked);
                        }}
                      />
                    </Fragment> */}
                        <ValidationText message={errors.phoneError} />
                      </TableCell>
                    </TableRow>

                    {!isFukuoka &&
                      isLanguage === languageType.ORIGIN &&
                      !paymentGroupId && (
                        <>
                          <TableRow>
                            <TableCell
                              className={[
                                classes.tableCellBorderNone,
                                classes.colLeft
                              ]}
                            >
                              <RequiredButton />
                            </TableCell>
                            <TableCell
                              className={[
                                classes.tableCellBorderNone,
                                classes.colRight
                              ]}
                            >
                              <Typography>
                                インボイス制度 適格事業者登録*
                              </Typography>
                              <RadioGroup
                                row
                                value={haveRegistrationId}
                                onChange={e => {
                                  setHaveRegistrationId(
                                    parseInt(e.target.value, 10)
                                  );
                                }}
                              >
                                <FormControlLabel
                                  value={0}
                                  control={<Radio color="primary" />}
                                  label="未登録"
                                  disabled={paymentGroupId}
                                />
                                <FormControlLabel
                                  value={1}
                                  control={<Radio color="primary" />}
                                  label="登録済み"
                                  disabled={paymentGroupId}
                                />
                              </RadioGroup>
                            </TableCell>
                          </TableRow>
                          {haveRegistrationId === 1 && (
                            <TableRow>
                              <TableCell
                                className={[
                                  classes.tableCellBorderNone,
                                  classes.colLeft
                                ]}
                              />
                              <TableCell
                                className={[
                                  classes.tableCellBorderNone,
                                  classes.colRight
                                ]}
                              >
                                <TextField
                                  required
                                  label="適格事業者登録番号"
                                  className={classes.textField}
                                  onChange={e => {
                                    if (e.target.value[0] === 'T') {
                                      setRegistrationId(e.target.value);
                                    } else if (!e.target.value) {
                                      setRegistrationId('T');
                                    }
                                  }}
                                  value={
                                    paymentGroupId
                                      ? groupRegistrationId
                                      : registrationId
                                  }
                                  onBlur={validRegistrationId}
                                  disabled={paymentGroupId}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                  fullWidth
                                />
                                <ValidationText
                                  message={errors.registrationIdError}
                                />
                                <Typography variant="h7">
                                  Tの後に続く13桁の番号を入力してください。
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      )}
                    <TableRow className={classes.borderBottom}>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colLeft
                        ]}
                      >
                        <RequiredButton />
                      </TableCell>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                      >
                        <TextField
                          required
                          label="メールアドレス"
                          defaultValue={editInput.email}
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          InputProps={{
                            readOnly: true
                          }}
                          onChange={e => {
                            setEmail(e.target.value);
                          }}
                          onBlur={validEmail}
                          disabled={
                            isFukuoka && educateSystem !== nameSystem.suita
                          }
                        />
                        <ValidationText message={errors.emailError} />
                      </TableCell>
                      <TableCell className={[classes.colRight, classes.fs12]}>
                        {isFukuoka ? (
                          <>
                            メールアドレスは、本事業に関する連絡や管理システムのログインIDとして利用します。メールアドレスを変更する場合は、ページ下部の「メールアドレス変更」より行ってください。
                          </>
                        ) : (
                          <>
                            メールアドレスは、ごちめしの各種ご連絡、および、管理システムのIDとしても利用いたします。
                            メールアドレスの変更を行いたい場合には、画面右上のメニュー(人マーク)の「メールアドレス変更」より行ってください。
                            <br />
                            <Text className={classes.textRed}>
                              注意：グループ管理者の方は一度ログアウトし、各店舗のID・パスワードで店舗管理者として再度ログイン後、ご変更ください。
                            </Text>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colLeft
                        ]}
                      >
                        <RequiredButton />
                      </TableCell>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                      >
                        <Typography
                          component="p"
                          className={classes.description}
                        >
                          {isFukuoka ? '振込先' : '売上受取方法'}
                        </Typography>
                        {!enableShopBank && (
                          <Typography
                            className={[classes.descriptionSmall, classes.fs12]}
                          >
                            ※&nbsp;グループで銀行口座を管理しているため、入金管理の設定・表示を行うことはできません。
                          </Typography>
                        )}

                        {editInput.accountStatus && (
                          <RadioGroup
                            value={depositManage}
                            onChange={e => {
                              setDepositManage(e.target.value);
                              convertDepositManageStr(e.target.value);
                            }}
                          >
                            <div>
                              <FormControlLabel
                                value="NONSELF"
                                control={
                                  <Radio
                                    color="primary"
                                    disabled={
                                      !enableShopBank ||
                                      editInput.accountStatus.stripeAccount ||
                                      (isFukuoka &&
                                        educateSystem !== nameSystem.suita)
                                    }
                                  />
                                }
                                label={
                                  isFukuoka
                                    ? '銀行口座'
                                    : '銀行口座で直接受取（月1回入金）（オプション）'
                                }
                              />
                              {!isFukuoka && (
                                <Typography
                                  className={[
                                    classes.subDescription,
                                    classes.fs12,
                                    classes.marginBottom10
                                  ]}
                                >
                                  月末締め翌月5営業日以内に当社より振込みいたします（振込手数料は店舗様負担となります）。
                                </Typography>
                              )}
                            </div>
                          </RadioGroup>
                        )}
                      </TableCell>
                    </TableRow>
                    {depositManage === 'NONSELF' && enableShopBank && (
                      <>
                        <TableRow>
                          <TableCell
                            className={[
                              classes.tableCellBorderNone,
                              classes.colRight
                            ]}
                          >
                            <TextField
                              required
                              label="銀行コード"
                              defaultValue={editInput.bankCode}
                              disabled={
                                !enableShopBank ||
                                (isFukuoka &&
                                  educateSystem !== nameSystem.suita)
                              }
                              placeholder="0000"
                              fullWidth
                              className={classes.textField}
                              margin="normal"
                              onChange={e => {
                                handleChangeBankCode(e.target.value);
                              }}
                              onBlur={validBankCode}
                              inputProps={{
                                maxLength: 4,
                                inputMode: 'numeric'
                              }}
                            />
                            <Typography className={classes.fs12}>
                              ※
                              <Link
                                href="https://zengin.ajtw.net/"
                                target="_blank"
                                className={classes.link}
                              >
                                検索サイト
                              </Link>
                            </Typography>
                            <Typography className={classes.fs12}>
                              半角数字・4桁（3桁以下の方は、先頭に0をつけて4桁にしてください）
                            </Typography>
                            <ValidationText message={errors.bankCodeError} />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            className={[
                              classes.tableCellBorderNone,
                              classes.colRight
                            ]}
                          >
                            <TextField
                              required
                              label="銀行名"
                              defaultValue={editInput.bankName}
                              disabled
                              fullWidth
                              className={[
                                classes.textField,
                                classes.disableInput
                              ]}
                              margin="normal"
                              value={bankName}
                            />
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                    {depositManage === 'NONSELF' && enableShopBank && (
                      <>
                        <TableRow>
                          <TableCell
                            className={[
                              classes.tableCellBorderNone,
                              classes.colRight
                            ]}
                          >
                            <TextField
                              required
                              label="支店コード"
                              defaultValue={editInput.bankBranchCode}
                              disabled={
                                !enableShopBank ||
                                (isFukuoka &&
                                  educateSystem !== nameSystem.suita)
                              }
                              placeholder="000"
                              fullWidth
                              className={classes.textField}
                              margin="normal"
                              onChange={e => {
                                setBankBranchCode(e.target.value);
                                setBankBranchName('');
                              }}
                              onBlur={validBankBranchCode}
                              inputProps={{
                                maxLength: 3,
                                inputMode: 'numeric'
                              }}
                              value={bankBranchCode}
                            />
                            <Typography className={classes.fs12}>
                              ※
                              <Link
                                href="https://zengin.ajtw.net/"
                                target="_blank"
                                className={classes.link}
                              >
                                検索サイト
                              </Link>
                            </Typography>
                            <Typography className={classes.fs12}>
                              半角数字・3桁（2桁以下の方は、先頭に0をつけて3桁にしてください）
                            </Typography>
                            <ValidationText
                              message={errors.bankBranchCodeError}
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            className={[
                              classes.tableCellBorderNone,
                              classes.colRight
                            ]}
                          >
                            <TextField
                              label="支店名"
                              defaultValue={editInput.bankBranchName}
                              disabled
                              fullWidth
                              className={[
                                classes.textField,
                                classes.disableInput
                              ]}
                              margin="normal"
                              value={bankBranchName}
                            />
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                    {depositManage === 'NONSELF' && enableShopBank && (
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <Typography className={classes.description}>
                            口座種別
                          </Typography>
                          <RadioGroup
                            row
                            value={bankAccountType}
                            onChange={e => {
                              setBankAccountType(e.target.value);
                              convertBankAccountTypeStr(e.target.value);
                            }}
                          >
                            <FormControlLabel
                              value="SAVINGS"
                              control={
                                <Radio
                                  color="primary"
                                  disabled={
                                    !enableShopBank ||
                                    (isFukuoka &&
                                      educateSystem !== nameSystem.suita)
                                  }
                                />
                              }
                              label="普通預金"
                            />
                            <FormControlLabel
                              value="CHECKING"
                              control={
                                <Radio
                                  color="primary"
                                  disabled={
                                    !enableShopBank ||
                                    (isFukuoka &&
                                      educateSystem !== nameSystem.suita)
                                  }
                                />
                              }
                              label="当座預金"
                            />
                          </RadioGroup>
                        </TableCell>
                      </TableRow>
                    )}
                    {depositManage === 'NONSELF' && enableShopBank && (
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <TextField
                            required
                            label="口座番号"
                            defaultValue={editInput.bankAccountNumber}
                            disabled={
                              !enableShopBank ||
                              (isFukuoka && educateSystem !== nameSystem.suita)
                            }
                            placeholder="1234567"
                            fullWidth
                            className={classes.textField}
                            margin="normal"
                            onChange={e => {
                              setBankAccountNumber(e.target.value);
                            }}
                            onBlur={validBankAccountNumber}
                          />
                          <ValidationText
                            message={errors.bankAccountNumberError}
                          />
                        </TableCell>
                      </TableRow>
                    )}
                    {depositManage === 'NONSELF' && enableShopBank && (
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight,
                            classes.fs12
                          ]}
                        >
                          {isFukuoka
                            ? '半角数字・7桁（6桁桁以下の方は先頭に0をつけて7桁にしてください）'
                            : '半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）'}
                        </TableCell>
                      </TableRow>
                    )}
                    {depositManage === 'NONSELF' && enableShopBank && (
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <TextField
                            required
                            label="口座名義"
                            defaultValue={editInput.bankAccountHolder}
                            disabled={
                              !enableShopBank ||
                              (isFukuoka && educateSystem !== nameSystem.suita)
                            }
                            placeholder="ヤマダ　タロウ"
                            fullWidth
                            className={classes.textField}
                            margin="normal"
                            onChange={e => {
                              setBankAccountHolder(e.target.value);
                            }}
                            onBlur={validBankAccountHolder}
                          />
                          <ValidationText
                            message={errors.bankAccountHolderError}
                          />
                        </TableCell>
                      </TableRow>
                    )}
                    {depositManage === 'NONSELF' && enableShopBank && (
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight,
                            classes.fs12
                          ]}
                        >
                          {isFukuoka
                            ? 'カタカナでご記入ください。'
                            : '必ず漢字/ひらがな以外でご記入ください。'}
                        </TableCell>
                      </TableRow>
                    )}
                    {depositManage === 'SELF' && enableShopBank && (
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight,
                            classes.fs12
                          ]}
                        >
                          <Divider />
                          <br />
                          第3者の決済サービス「Stripe&nbsp;Connect」を利用して頂く事で、自社で入金サイクル（基本は毎週）を変更したり、振込手数料を無料にする事ができます。こちらのオプションを選んだ場合は、以下の設定を行って頂きます。
                          <br />
                          <br />
                          ①&nbsp;Stripeでアカウントを作成する。
                          <br />
                          ②&nbsp;ごちめしを運営する当社のStripeアカウントに紐付けを行う。
                          <br />
                          ③&nbsp;初回入金時に、Stripe社より送られる案内メールにしたがって、本人確認資料を提出する。
                          <br />
                          <br />
                          管理画面左上の三本線メニューから、「その他」→「自社で入金管理（オプション）」を選んで頂くと、上記の①および②の設定が一度に行う事ができます。設定の詳細については、当管理システムのトップページから「ごちめし店舗登録マニュアルはこちら」をご参照ください。
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}
              </TableBody>
            </Table>
            {/* <Divider className={classes.divider} />
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell className={classes.tableCellBorderNone}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={consent}
                        onChange={e => {
                          setConsent(e.target.checked);
                        }}
                        color="primary"
                      />
                    }
                    label="ごちめし加盟店規約に同意する"
                  />
                </TableCell>
              </TableRow>
            </Table>
            <Divider className={classes.divider} />
            <div className={classes.clsActions}>
              <CancelButtonShop onClickAction={cancelAction} color="primary" />
              <Button
                variant="contained"
                disabled={!consent}
                color="primary"
                onClick={handleNext}
                className={classes.button}
              >
                次へ
              </Button>
            </div> */}
          </TabPanelDetail>

          <TabPanelDetail value={valueTab} index={1}>
            <Table className={classes.editTable}>
              <TableBody>
                <TableRow className={classes.borderBottom}>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label={isFukuoka ? '教室概要' : '店舗概要'}
                      placeholder={
                        isFukuoka ? '' : '創業年、お店の特徴、雰囲気　など'
                      }
                      fullWidth
                      multiline
                      rows="4"
                      defaultValue={editInput.introduction}
                      value={introduction}
                      className={classes.textField}
                      margin="normal"
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 1000 : 2500
                      }}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      onChange={e => {
                        setIntroduction(e.target.value);
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow className={classes.borderBottom}>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="営業時間"
                      placeholder={
                        isFukuoka
                          ? ''
                          : '平日11：00～14：00 （LO 13：30）/土日祝11：00～14：00 （LO 13：30）'
                      }
                      defaultValue={editInput.businessHours}
                      value={businessHours}
                      fullWidth
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 250 : 1000
                      }}
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      onChange={e => {
                        setBusinessHours(e.target.value);
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow className={classes.borderBottom}>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="定休日"
                      placeholder="第2・第4土曜、日曜、祝日"
                      defaultValue={editInput.holiday}
                      value={holiday}
                      fullWidth
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 250 : 1000
                      }}
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      onChange={e => {
                        setHoliday(e.target.value);
                      }}
                    />
                  </TableCell>
                </TableRow>
                {isLanguage === languageType.ORIGIN && (
                  <TableRow className={classes.borderBottom}>
                    <TableCell className={classes.colLeft}>
                      <AnyButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <TextField
                        label={isFukuoka ? '平均金額' : '価格帯'}
                        placeholder="○○～○○円"
                        defaultValue={editInput.priceRange}
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          setPriceRange(e.target.value);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                )}
                <TableRow className={classes.borderBottom}>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="最寄り駅"
                      placeholder="○○線○○駅"
                      defaultValue={editInput.nearestStation}
                      value={nearestStation}
                      fullWidth
                      inputProps={{
                        maxLength: 250
                      }}
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      onChange={e => {
                        setNearestStation(e.target.value);
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow className={classes.borderBottom}>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="アクセス"
                      placeholder="（交通手段、最寄り駅など）より○○分"
                      defaultValue={editInput.access}
                      value={access}
                      fullWidth
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 250 : 1000
                      }}
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      onChange={e => {
                        setAccess(e.target.value);
                      }}
                    />
                  </TableCell>
                </TableRow>
                {isLanguage === languageType.ORIGIN && (
                  <TableRow className={classes.borderBottom}>
                    <TableCell className={classes.colLeft}>
                      <AnyButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <TextField
                        label="WebページURL"
                        defaultValue={editInput.webPage}
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          setWebPage(e.target.value);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <TableRow className={classes.borderBottom}>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        label="タグ"
                        defaultValue={editInput.tagStr}
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          setTagStr(e.target.value);
                          splitTagStr(e.target.value);
                        }}
                      />
                    </TableCell>
                    <TableCell className={[classes.colRight, classes.fs12]}>
                      {isFukuoka ? (
                        <>
                          {isFukuoka && educateSystem !== nameSystem.suita && (
                            <div>
                              ※
                              <span
                                className={classNames(
                                  classes.textRed,
                                  classes.fw700
                                )}
                              >
                                事務局で登録済のタグを削除しないでください。
                              </span>
                              タグの追加は問題ありません。
                            </div>
                          )}
                          {isFukuoka &&
                            educateSystem !== nameSystem.suita &&
                            '※'}
                          半角の#をつけて
                          <span className={classes.tagCaution}>
                            スペースで区切ってください。
                          </span>
                        </>
                      ) : (
                        <>
                          #イタリアン #飲み会に #港区 など、半角の#をつけて
                          <span className={classes.tagCaution}>
                            スペースで区切ってください。
                          </span>
                          <br />
                          店舗のカテゴリー・特徴・売りなどをこちらのタグで表現して頂きます。
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN ? (
                  <TableRow className={classes.borderBottom}>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <FileUpload
                        label="image1"
                        setFile={setImage1}
                        previewImage={previewImage1}
                        setPreviewImage={setPreviewImage1}
                      />
                      <FileUpload
                        label="image2"
                        setFile={setImage2}
                        previewImage={previewImage2}
                        setPreviewImage={setPreviewImage2}
                      />
                      <FileUpload
                        label="image3"
                        setFile={setImage3}
                        previewImage={previewImage3}
                        setPreviewImage={setPreviewImage3}
                      />
                      <FileUpload
                        label="image4"
                        setFile={setImage4}
                        previewImage={previewImage4}
                        setPreviewImage={setPreviewImage4}
                      />
                      <FileUpload
                        label="image5"
                        setFile={setImage5}
                        previewImage={previewImage5}
                        setPreviewImage={setPreviewImage5}
                      />
                    </TableCell>
                    <TableCell className={[classes.colRight, classes.fs12]}>
                      <div
                        style={{
                          whiteSpace: 'break-spaces'
                        }}
                      >
                        {getTextBySystem(
                          '画像は１枚につき8MB以内でお願いします。\n画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。\n店舗一覧には１番目に登録した画像が表示されます。',
                          educateSystem
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow className={classes.tableRowBorderNone}>
                    <TableCell
                      className={[classes.colRight, classes.width320]}
                    />
                  </TableRow>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <TableRow className={classes.borderBottom}>
                    <TableCell className={classes.colLeft}>
                      <AnyButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <div className={classes.margin}>
                        <Grid container spacing={1} alignItems="flex-end">
                          <Grid item>
                            <CardMedia
                              component="img"
                              alt="Facebook"
                              height="24"
                              image="/images/icon_facebook.png"
                              title="Facebook"
                              className={[classes.marginBottom10]}
                            />
                          </Grid>
                          <Grid item xs={12} sm container>
                            <TextField
                              label="Facebook"
                              placeholder="https://www.facebook.com/---"
                              defaultValue={editInput.snsFacebook}
                              fullWidth
                              className={classes.textField}
                              margin="normal"
                              onChange={e => {
                                setSnsFacebook(e.target.value);
                              }}
                              onBlur={validSnsFacebook}
                            />
                          </Grid>
                        </Grid>
                        <ValidationText message={errors.snsFacebookError} />
                        <Grid container spacing={1} alignItems="flex-end">
                          <Grid item>
                            <CardMedia
                              component="img"
                              alt="Twitter"
                              height="24"
                              image="/images/icon_twitter.png"
                              title="Twitter"
                              className={[classes.marginBottom10]}
                            />
                          </Grid>
                          <Grid item xs={12} sm container>
                            <TextField
                              label="Twitter"
                              placeholder="https://www.twitter.com/---"
                              defaultValue={editInput.snsTwitter}
                              fullWidth
                              className={classes.textField}
                              margin="normal"
                              onChange={e => {
                                setSnsTwitter(e.target.value);
                              }}
                              onBlur={validSnsTwitter}
                            />
                          </Grid>
                        </Grid>
                        <ValidationText message={errors.snsTwitterError} />
                        <Grid container spacing={1} alignItems="flex-end">
                          <Grid item>
                            <CardMedia
                              component="img"
                              alt="Instagram"
                              height="24"
                              image="/images/icon_instagram.png"
                              title="Instagram"
                              className={[classes.marginBottom10]}
                            />
                          </Grid>
                          <Grid item xs={12} sm container>
                            <TextField
                              label="Instagram"
                              placeholder="https://www.instagram.com/---"
                              defaultValue={editInput.snsInstagram}
                              fullWidth
                              className={classes.textField}
                              margin="normal"
                              onChange={e => {
                                setSnsInstagram(e.target.value);
                              }}
                              onBlur={validSnsInstagram}
                            />
                          </Grid>
                        </Grid>
                        <ValidationText message={errors.snsInstagramError} />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
                {!isFukuoka && (
                  <>
                    <TableRow className={classes.borderBottom}>
                      <TableCell className={classes.colLeft}>
                        <AnyButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <TextField
                          label="座席"
                          placeholder="カウンター○席、個室○室"
                          defaultValue={editInput.numberSit}
                          value={numberSit}
                          fullWidth
                          inputProps={{
                            maxLength: 250
                          }}
                          className={classes.textField}
                          margin="normal"
                          disabled={
                            isLanguage !== languageType.ORIGIN &&
                            translateType === 0
                          }
                          onChange={e => {
                            setNumberSit(e.target.value);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow className={classes.borderBottom}>
                      <TableCell className={classes.colLeft}>
                        <AnyButton />
                      </TableCell>
                      <TableCell className={classes.colRight}>
                        <TextField
                          label="禁煙/喫煙"
                          defaultValue={editInput.smoking}
                          value={smoking}
                          fullWidth
                          inputProps={{
                            maxLength: 250
                          }}
                          className={classes.textField}
                          margin="normal"
                          disabled={
                            isLanguage !== languageType.ORIGIN &&
                            translateType === 0
                          }
                          onChange={e => {
                            setSmoking(e.target.value);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="駐車場"
                      placeholder={isFukuoka ? '' : 'お店から徒歩○分に〇台'}
                      defaultValue={editInput.parking}
                      value={parking}
                      fullWidth
                      inputProps={{
                        maxLength: 250
                      }}
                      className={classes.textField}
                      margin="normal"
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      onChange={e => {
                        setParking(e.target.value);
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            {/* <br />
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={consentStep2}
                        onChange={e => {
                          setConsentStep2(e.target.checked);
                        }}
                        color="primary"
                      />
                    }
                    label={
                      <span className={classes.font12}>
                        ごちめし加盟店規約に同意する
                      </span>
                    }
                  />
                </TableCell>
              </TableRow>
            </Table>
            <Divider />
            <div className={classes.clsActions}>
              <Button color="primary" onClick={handleBack}>
                戻る
              </Button>
              <ConfirmButton
                onClickAction={confirmAction}
                consent={consentStep2}
              />
            </div> */}
          </TabPanelDetail>

          <TabPanelDetail value={valueTab} index={2}>
            <Table className={classes.editTable}>
              <TableBody>
                <TableRow className={classes.borderBottom}>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Typography className={classes.description}>
                      店舗詳細表示制限
                    </Typography>
                    <RadioGroup
                      row
                      value={stealthMode}
                      onChange={e => {
                        setStealthMode(e.target.value);
                        convertStealthModeStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="UNSTEALTH"
                        control={<Radio color="primary" />}
                        label="店舗詳細表示"
                      />
                      <FormControlLabel
                        value="STEALTH"
                        control={<Radio color="primary" />}
                        label="店舗詳細非表示"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={[classes.colRight, classes.fs12]}>
                    GOCHIプラットフォーム提供サイトにて、店舗ページの表示を設定できます。
                    <br />
                    ※デフォルト設定は「店舗詳細表示」＝店舗ページの表示を推奨しております。
                    <br />
                    ※店舗情報を提供サイトで一時的に表示したくない場合などでご活用ください。
                  </TableCell>
                </TableRow>
                <TableRow className={classes.borderBottom}>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Typography className={classes.description}>
                      誰でもごち制限
                    </Typography>
                    <RadioGroup
                      row
                      value={gochiRestriction}
                      onChange={e => {
                        setGochiRestriction(e.target.value);
                        convertGochiRestrictionStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="MENTION_ONLY"
                        control={<Radio color="primary" />}
                        label="指名ごちのみ"
                      />
                      <FormControlLabel
                        value="ANY"
                        control={<Radio color="primary" />}
                        label="制限なし"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={[classes.colRight, classes.fs12]}>
                    GOCHIプラットフォーム提供サイトにて、誰でもごち（特定の相手では無く、どなたにでも利用いただけるチケット）を利用いただける設定項目です。
                    <br />
                    ※デフォルト設定は「指名ごち」＝「誰でもごち」を使用しない形式を推奨しております。
                    <br />
                    ※「誰でもごち」を利用される場合、
                    <Link
                      href="https://shop-guide.gochimeshi.com/faq/06-2/"
                      target="_blank"
                    >
                      こちらのページ
                    </Link>
                    をお読みになってからご利用ください。
                  </TableCell>
                </TableRow>
                <TableRow className={classes.borderBottom}>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Typography className={classes.description}>
                      社食ごちめし金額指定チケット利用の有無
                    </Typography>
                    <RadioGroup
                      row
                      value={allowMenuPriceShashoku}
                      onChange={e => {
                        setAllowMenuPriceShashoku(parseInt(e.target.value, 0));
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        disabled={!editInput.isShopCanEditSetting}
                        control={<Radio color="primary" />}
                        label="利用する"
                      />
                      <FormControlLabel
                        value={0}
                        disabled={!editInput.isShopCanEditSetting}
                        control={<Radio color="primary" />}
                        label="利用しない"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={[classes.colRight, classes.fs12]}>
                    GOCHIプラットフォーム提供サイト「社食ごちめし」にて、金額を指定してお食事ができる機能となります。GOCHIプラットフォームに登録していないメニューの決済も、金額を入力した決済ができるため、可能となります。
                    <br />
                    例）ご利用ユーザー様が550円と入力すると、550円の決済が可能となります。
                    <br />
                    ※デフォルト設定は「利用する」を推奨しております。
                    <br />
                    ※「利用しない」を設定される場合、メニュー登録の充実や定期更新などをお願いしております。
                  </TableCell>
                </TableRow>
                {/* <TableRow className={classes.borderBottom}>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Typography className={classes.description}>
                      社食ごちめし現金授受の有無
                    </Typography>
                    <RadioGroup
                      row
                      value={cashAllowed}
                      onChange={e => {
                        const allowed = parseInt(e.target.value, 10);
                        setCashAllowed(allowed);
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="受け付けない"
                        disabled
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="受け付ける"
                        disabled
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={[classes.colRight, classes.fs12]}>
                    GOCHIプラットフォーム提供の「社食ごちめし」サイトにて、企業負担予算を超過してお支払いが発生する際に、差額を現金でお支払いできる機能です。
                    <br />
                    例）1,000円のメニューに対して、社食費用が500円の場合、差額の500円を現金で支払う
                    <br />
                    本項目につきましては、キャッシュレス決済を推進させていただき、現金授受を受け付けない設定とさせていただきます。
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <Typography className={classes.description}>
                      差額決済利用可否
                    </Typography>
                    <RadioGroup
                      row
                      value={allowGapPayment}
                      onChange={e => {
                        const allowed = parseInt(e.target.value, 10);
                        setAllowGapPayment(allowed);
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="可能 （券売機で営業または通販サービス）"
                      />
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="不可（上記以外）"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={[classes.colRight, classes.fs12]}>
                    GOCHIプラットフォーム提供の「社食ごちめし」サイトにて、企業負担予算以外でお支払いが発生する際に、GOCHIプラットフォーム内の決済機能を利用しお支払いできる機能です。尚、この機能を利用し決済を行った場合は、お支払いいただく方に10%の手数料が発生します。
                    <br />
                    例）1,000円のメニューに対して、社食費用が500円の場合、差額の500円に手数料10％の50円を加えた550円をお支払いいただく。
                    <br />
                    メニューの販売形態が通信販売や食券制等、店頭で直接お支払い出来ない場合は必ず”差額決済可能”をお選びください。
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TabPanelDetail>

          <div className={classes.boxButtonAction}>
            <CancelButtonShop onClickAction={cancelAction} color="primary" />
            <ConfirmButton onClickAction={confirmAction} />
          </div>
          <Modal open={openEditConfirm} className={classes.modalMobile}>
            <ShopEditConfirmShop
              backAction={backAction}
              editAction={editAction}
              editConfirm={editConfirm}
              enableShopBank={enableShopBank}
              openEditProgress={openEditProgress}
              progressOkAction={progressOkAction}
              loading={loading}
              resultMessage={resultMessage}
              roles={roles}
              isFukuoka={isFukuoka}
            />
          </Modal>
        </Paper>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
